export default {
      id: "chevron-down-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-46b249.svg#chevron-down-usage",
      toString: function () {
        return this.url;
      }
    }